import SessionsTable from '@/components/SessionsTable/SessionsTable';
import { SessionStatus } from '@/lib/types/session-status';
import { SessionHub } from '@addmile/backend-client';

import SessionInfo from './SessionInfo/SessionInfo';

interface SessionsProps {
  sessions: SessionHub[];
}

const Sessions = ({ sessions }: SessionsProps) => {
  return (
    <div className="flex justify-start gap-8 animation-appear">
      <SessionsTable
        sessions={sessions.filter((session) => session.status !== SessionStatus.New)}
      />
      <SessionInfo sessions={sessions} />
    </div>
  );
};

export default Sessions;
